import { render } from "./Chankang.vue?vue&type=template&id=41e07790&ts=true"
import script from "./Chankang.vue?vue&type=script&lang=ts"
export * from "./Chankang.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__